jQuery.fn.InitializeSearchPage = function (option) {
    var defaults = {
        initialJsonData: null,
        serviceUrl: null,
        pinnedInsights: null
    };
    var option = $.extend({}, defaults, option);
    var $filtersTrigger = $('.js-customize-filters-trigger');
    // Load JSON data from model
    var viewModelJs = JSON.parse(option.initialJsonData);
    var pinnedItems = JSON.parse(option.pinnedInsights);
    var viewModel = ko.mapping.fromJS(viewModelJs);
    var guidEmpty = '00000000-0000-0000-0000-000000000000';
    //var $scrollDefaultPosition = $('.js-scroll-default-position');
    var $scrollDefaultPosition = $('.highlights-module');
    var defaultScrollTop = $scrollDefaultPosition.offset().top - 100;
    var pageContent = $(this);
    var keyWordIDKey = 'KEYWORD';
    //force reit filter in services to have PracticeFilters ParentName
    for(var i = 0;i<viewModel.SearchFilters.PracticeFilters().length; i++){
        var filter = viewModel.SearchFilters.PracticeFilters()[i]
        if(filter.Name().toLowerCase().indexOf('reit') > 0){
            filter.ParentName('ServiceFilters');
            break;
        }
    }
    var lastChangedType = '';

    // Extend View Model
    viewModel.DisplayPinnedItems = ko.observable(true);
    viewModel.SelectedFilters = ko.observableArray();
    viewModel.IsSearchRunning = ko.observable(false);
    viewModel.HasSearchRun = ko.observable(false);
    viewModel.IsSelectAll = ko.observable(false);
    viewModel.IsClearAll = ko.observable(false);
    viewModel.HasPendingUpdates = ko.observable(false);
    viewModel.ScrollPositionUpdate = ko.observable(false);
    viewModel.ActivePageView = ko.observable("featured");
    viewModel.ActiveEventsPageView = ko.observable("upcomingevents");
    viewModel.ActivePracticeFilter = ko.observable();
    viewModel.ActiveArticleTypeFilter = ko.observable();
    viewModel.DisplaySetFilters = ko.observable(false);
    viewModel.EventTypeFilter = ko.observable();
    viewModel.UpcomingEventsTake = ko.observable(viewModel.SearchFilters.InitialPageSize());

    //ViewModel Init - During Page Load
    viewModel.Init = function (viewModel) {
            ko.utils.arrayForEach(viewModel.GridData(), function (articleEntity) {
                if (articleEntity != null && articleEntity.IsExternalLink()) {
                    viewModel.AddExternalIconToArticleTitleHtml(articleEntity);
                }
            });
    }

    viewModel.KeywordSubmit = function (data, event) {
        if (event.keyCode === 13) {
            viewModel.SearchFilters.KeywordFilter(event.target.value);
        }

        return true;
    };

    viewModel.GetUpcomingEventPagination = ko.computed(function () {
            return viewModel.UpcomingEvents().slice(0, viewModel.UpcomingEventsTake());
    });

    viewModel.LoadNextUpcomingEventsPage = function () {
        var take = viewModel.UpcomingEventsTake() + viewModel.SearchFilters.Take();
        viewModel.UpcomingEventsTake(take);
    };

    viewModel.HasSelectedFilters = function () {
        if (viewModel.SearchFilters.KeywordFilter() != null && viewModel.SearchFilters.KeywordFilter().length > 0) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.PracticeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
		}
		var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.OfficeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.IndustryFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.TypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });

        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.EventTypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });

        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });

        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.PastDateFilters(), function (item) {
            return (item.IsSelected() == true);
        });

        if (hasItem != null) {
            return true;
        }

        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.FutureDateFilters(), function (item) {
            return (item.IsSelected() == true);
        });

        if (hasItem != null) {
            return true;
        }
        return false;
    };

    viewModel.SetActiveType = function () {
        viewModel.EventTypeFilter().IsSelected(true);
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    }

    viewModel.ResetDropdown = function (parentName) {
        if (parentName === "All" || parentName === "Publications" || parentName === "Blogs" || parentName === "News" || parentName === "In Our Words" || parentName === "Events") {
            return;
        } else {
            var dropdowns = $('.js-drop-down.' + parentName);
            var currentValue = dropdowns.find('span')[0];
            var firstValue = dropdowns.find('li.drop-down-item.default')[0];
            if (firstValue !== undefined)
                currentValue.innerHTML = firstValue.innerHTML;
        }
    };

    //Reset Dropdown All Drop Downs
    viewModel.ResetAllDropdowns = function () {
        var dropdowns = $('.filter-dropdown');
        var currentValues = dropdowns.find('span');
        var firstValues = dropdowns.find('li.drop-down-item.default');

        if (currentValues.length === firstValues.length) {
            for (i = 0; i < firstValues.length; i++) {
                currentValues[i].innerHTML = firstValues[i].innerHTML;
            }
        }
    };

    viewModel.DecodeHtmlInput = function (encodedString) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        return textArea.value != null && textArea.value != "null" ? textArea.value : "";
    };
    viewModel.SearchFiltersSet = ko.computed(function () {
        return viewModel.HasSelectedFilters();
    });
    viewModel.SetActivePageView = function (activepage) {
        if (activepage !== "")
            viewModel.ActivePageView(activepage);
        else
            viewModel.ActivePageView("featured");
    };
    viewModel.SetActiveEventsPageView = function (activepage) {
        viewModel.ResetPracticeFilter("date");
        if (activepage !== "")
            viewModel.ActiveEventsPageView(activepage);
        else
            viewModel.ActiveEventsPageView("upcomingevents");
    };
    viewModel.IsVisibleList = ko.computed(function () {
        var activePage = viewModel.ActivePageView();
        var activeEventPage = viewModel.ActiveEventsPageView();
        var activeArticleFilter = viewModel.ActiveArticleTypeFilter();
        var searchFilterSet = viewModel.SearchFiltersSet();
        if (activeArticleFilter === "Events" && activeEventPage !== "upcomingevents") {
            return true;
        } else if (activeArticleFilter === "Events" && activeEventPage === "upcomingevents") {
            return false;
        } else if (activePage === "latest" || searchFilterSet === true) {
            return true;
        }
    });
    viewModel.IsActivePageView = function (activepage) {
        return (viewModel.ActivePageView() === activepage);
    };
    viewModel.IsActiveEventPageView = function (activepage) {
        return (viewModel.ActiveEventsPageView() === activepage);
    };
    viewModel.GetFirstCategory = function (inputstr) {
        if (inputstr !== "") {
            var categoryTypes = inputstr.split("|");
            if (categoryTypes !== "" && categoryTypes.length !== 0)
                return categoryTypes[0];
        }
    };
    viewModel.GetCurrentArticleFilter = function () {
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        return hasItem;
    };
    viewModel.GetPinnedResultList = ko.computed(function () {
        var currentFilter = viewModel.GetCurrentArticleFilter();
        if (currentFilter !== null && currentFilter !== "") {
            var insightList = ko.utils.arrayFirst(pinnedItems, function (item) {
                return (item.Type === currentFilter.Name());
            });
            if (insightList !== null && insightList !== undefined)
                return insightList.Insights;
        }
    });
    // Onstate change for history
    window.onstatechange = function () {
        var currentState = History.getState();
        var qs = History.getState().data['qs'];
        var qsParms = !!qs ? parseQueryString(qs) : {};

        var currentSkip = viewModel.GridData().length;
        var newSkip = 0;
        var filterCount = 0;
        if (!!qsParms.skip && qsParms.skip > 0) {
            newSkip = parseInt(qsParms.skip);
        }
        var projectedTotal = newSkip + viewModel.SearchFilters.Take();
        if (projectedTotal < currentSkip && newSkip != 0) {
            // This is here for a back button after a page scroll
            viewModel.IsSearchRunning(true);
            viewModel.HasMoreResults(true);
            viewModel.UpcomingEventsHasMoreResults(true);
            viewModel.HasSearchRun(true);
            viewModel.SearchFilters.Skip(newSkip);
            while (viewModel.GridData().length > projectedTotal) {
                var popped = viewModel.GridData.pop();
            }
            viewModel.IsSearchRunning(false);
        } else {
            // New filters have been selected so run search
            var existingFiltersTypeFilters = new Array();
            if (!!qsParms.articletypes && qsParms.articletypes.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
                    var output = {
                        ID: item.ID(),
                        Filters: item.Filter(),
                        IsSelected: item.IsSelected(),
                        Name: item.Name()
                    };
                    existingFiltersTypeFilters.push(output);
                });
            }

            viewModel.SearchFilters.ClearAllSearchFilters();
            var hasFilters = false;
            var reloadFilters = false;
            var containsAdditionalFilters = false;

            if (!!qsParms.reload && qsParms.reload.length > 0) {
                reloadFilters = (qsParms.reload == "true");
            }

            viewModel.SearchFilters.ReloadFilters(reloadFilters);

            if (!!qsParms.keyword && qsParms.keyword.length > 0) {
                viewModel.SearchFilters.KeywordFilter(qsParms.keyword);
                hasFilters = true;
                containsAdditionalFilters = true;
            }

            viewModel.SearchFilters.Skip(newSkip);

            if (!!qsParms.services && qsParms.services.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.PracticeFilters(), function (item) {
                    if (qsParms.services.indexOf(item.ID()) >= 0) {
                        if(!(item.ID() === '0a774288-0858-454b-af7c-1614bd4680df' && lastChangedType === 'IndustryFilter')){
                            debugger;
                            item.IsSelected(true);
                            hasFilters = true;
                            containsAdditionalFilters = true;
                        }
                    }
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
                    if (qsParms.services.indexOf(item.ID()) >= 0) {
                        if(!(item.ID() === '0a774288-0858-454b-af7c-1614bd4680df' && lastChangedType === 'ServiceFilters')){
                            item.IsSelected(true);
                            hasFilters = true;
                            containsAdditionalFilters = true;
                        }
                    }
                });
            }
            if (!!qsParms.types && qsParms.types.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.TypeFilters(), function (item) {
                    if (qsParms.types.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                    }
                });
            }
            if (!!qsParms.other && qsParms.other.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
                    if (qsParms.other.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                        containsAdditionalFilters = true;
                    }
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
                    if (qsParms.other.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                        containsAdditionalFilters = true;
                    }
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.EventTypeFilters(), function (item) {
                    if (qsParms.other.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                        containsAdditionalFilters = true;
                    }
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
                    if (qsParms.other.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                        containsAdditionalFilters = true;
                    }
                });
            }
            if (!!qsParms.articletypes && qsParms.articletypes.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
                    ko.utils.arrayForEach(existingFiltersTypeFilters, function (obj) {
                        if (item.ID() === obj.ID && item.Name() === obj.Name && obj.IsSelected === true) {
                            item.IsSelected(true);
                        }
                    });
                });
            }
            if (!!qsParms.date && qsParms.date.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.PastDateFilters(), function (item) {
                    if (qsParms.date.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                        containsAdditionalFilters = true;
                    }
                });
            }

            if (!!qsParms.date && qsParms.date.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.FutureDateFilters(), function (item) {
                    if (qsParms.date.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                        containsAdditionalFilters = true;
                    }
                });
            }

            if (!!qsParms.datefrom && qsParms.datefrom.length > 0) {
                viewModel.SearchFilters.DateFrom(qsParms.datefrom);
            }

            if (!!qsParms.dateto && qsParms.dateto.length > 0) {
                viewModel.SearchFilters.DateTo(qsParms.dateto);
            }

            if (!viewModel.ScrollPositionUpdate()) {
                viewModel.LoadDataFromServer();
                viewModel.HasSearchRun(hasFilters);
            }

            if (containsAdditionalFilters === true) {
                viewModel.DisplaySetFilters(containsAdditionalFilters);
            }
        }
        // Reposition by scoll position
        var scrollPosition = 0;
        if (!!qsParms.scroll && qsParms.scroll.length > 0) {
            scrollPosition = parseInt(qsParms.scroll);
        }
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
        return;
    }

    viewModel.setLastChanged = function(obj) {
        if(obj.ID() === '0a774288-0858-454b-af7c-1614bd4680df')
            lastChangedType = obj.ParentName();
        viewModel.SearchFilters.PracticeFilters.toggleSingleSelectFilter(obj)
    }

    // Build query string based on filters
    viewModel.QueryString = function (forceScrollPosition) {
        var queryString = "";
        if (viewModel.SearchFilters.KeywordFilter() != null && viewModel.SearchFilters.KeywordFilter().length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "keyword=" + encodeURIComponent(viewModel.SearchFilters.KeywordFilter());
        }
        var selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.PracticeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "services=" + selectedItems.join();
        }
        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.TypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "types=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "other=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "other=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.EventTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "other=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "other=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.PastDateFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
                var dateArray = item.Url().split("|");
                if (!!dateArray && dateArray.length == 2) {
                    viewModel.SearchFilters.DateFrom(dateArray[0])
                    viewModel.SearchFilters.DateTo(dateArray[1])
                }
            }
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.FutureDateFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
                viewModel.UpcomingEventsTake(viewModel.SearchFilters.InitialPageSize());
                var dateArray = item.Url().split("|");
                if (!!dateArray && dateArray.length == 2) {
                    viewModel.SearchFilters.DateFrom(dateArray[0])
                    viewModel.SearchFilters.DateTo(dateArray[1])
                }
            }
        });

        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "date=" + selectedItems.join();
        } else {
            viewModel.SearchFilters.DateFrom("");
            viewModel.SearchFilters.DateTo("");
        }

        if (!!viewModel.SearchFilters.DateFrom() && viewModel.SearchFilters.DateFrom().length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "datefrom=" + viewModel.SearchFilters.DateFrom();
        }
        if (!!viewModel.SearchFilters.DateTo() && viewModel.SearchFilters.DateTo().length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "dateto=" + viewModel.SearchFilters.DateTo();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                if (item.ID() !== guidEmpty && item.Name() !== "All" && item.ID() !== "129feaed-29d8-46c4-bcf0-a739905dbe50") {
                    selectedItems.push(item.ID());
                } else {
                    viewModel.SearchFilters.ClearSelectedFilters(true);
                    return;
                }
            }
        });

        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "articletypes=" + selectedItems.join();
        }

        if (viewModel.SearchFilters.Skip() > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "skip=" + viewModel.SearchFilters.Skip();
        }
        queryString += (queryString != "" ? "&" : "?");
        queryString += "reload=" + viewModel.SearchFilters.ReloadFilters();
        queryString += (queryString != "" ? "&" : "?");

        if (!!forceScrollPosition && forceScrollPosition > 0) {
            queryString += "scroll=" + forceScrollPosition;
        } else {
            queryString += "scroll=" + $(window).scrollTop();
        }
        return queryString;
    };

    // Run search by pushing new state
    viewModel.Search = function () {
        var windowPosition = (viewModel.HasSelectedFilters()) ? $scrollDefaultPosition.offset().top - 100 : 1;

        if (viewModel.HasPendingUpdates() === false || (viewModel.HasSelectedFilters() === false && viewModel.HasPendingUpdates() === true && viewModel.SelectedFilters().length < 1)) {
            return;
        }

        if (!viewModel.HasSelectedFilters()) {
            $filtersTrigger.text($filtersTrigger.data('expanded-label'))
        }

        viewModel.SearchFilters.Skip(0);
        var qs = viewModel.QueryString(windowPosition);
        viewModel.ScrollPositionUpdate(false);
        History.pushState({ qs: qs }, History.options.initialTitle, qs);
    }

    viewModel.KeywordSearch = function (data, event) {
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    }

    // Load next page
    viewModel.LoadNextPage = function () {
        viewModel.SearchFilters.Skip(viewModel.GridData().length);
        var qs = viewModel.QueryString();
        viewModel.ScrollPositionUpdate(false);
        History.pushState({ qs: qs }, History.options.initialTitle, qs);
    }

    // Load data from server
    viewModel.LoadDataFromServer = function () {
        viewModel.IsSearchRunning(true);
        var viewModelToSend = GetRequestObject(viewModel.SearchFilters);

        $.ajax({
            url: option.serviceUrl,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: ko.mapping.toJSON(viewModelToSend),
            cache: false,
            success: function (data) {
                var results = ko.observableArray();
                var resultsUpcoming = ko.observableArray();
                if (viewModel.SearchFilters.Skip() == 0) {
                    viewModel.ResultCount(0);
                    viewModel.UpcomingEventsResultCount(0);
                    viewModel.GridData.removeAll();
                    viewModel.UpcomingEvents.removeAll();
                }
                ko.mapping.fromJS(data.GridData, {}, results);
                ko.utils.arrayForEach(results(), function (item) {
                    viewModel.AddExternalIconToArticleTitleHtml(item);
                    viewModel.GridData.push(item);
                });

                ko.mapping.fromJS(data.UpcomingEvents, {}, resultsUpcoming);
                ko.utils.arrayForEach(resultsUpcoming(), function (item) {
                    viewModel.UpcomingEvents.push(item);
                });
                viewModel.ResultCount(data.ResultCount);
                viewModel.UpcomingEventsResultCount(data.UpcomingEventsResultCount);
                viewModel.HasMoreResults(data.HasMoreResults);
                viewModel.UpcomingEventsHasMoreResults(data.UpcomingEventsHasMoreResults);
                viewModel.SearchFilters.KeywordFilter(viewModel.DecodeHtmlInput(data.SearchFilters.KeywordFilter));
                viewModel.SearchFilters.ReloadFilters(data.SearchFilters.ReloadFilters);
                viewModel.SetSelectedFilters();
                viewModel.HasPendingUpdates(false);
                viewModel.IsSearchRunning(false);
            },
            error: function (xhr, textStatus, errorThrown) {
                console.log(xhr);
                console.log("textStatus : " + textStatus);
                console.log("errorThrown : " + errorThrown);
            }
        });
    }
    //Templating Article Title
    viewModel.AddExternalIconToArticleTitleHtml = function (articleEntity) {
        if (articleEntity != null && articleEntity.IsExternalLink()) {
            articleEntity.Title(articleEntity.Title() + ' <i class="fa fa-external-link external-link" aria-hidden="true"></i>');
        }
    };

    //Clear search filter
    viewModel.ClearFilter = function (parentName) {
        viewModel.SearchFilters.ClearSearchFilter(parentName);
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    };

    // Animations for new lit items
    viewModel.animateGridInsert = function (elem) { if (elem.nodeType === 1) $(elem).hide().fadeIn(800) }
    viewModel.animateGridDelete = function (elem) { if (elem.nodeType === 1) $(elem).fadeOut(800, function () { $(elem).remove(); }) }

    // Clear all filters and run search
    viewModel.SearchFilters.ClearSelectedFilters = function (allFilters) {
        viewModel.SearchFilters.ClearAllSearchFilters(allFilters);
        viewModel.SelectedFilters.removeAll();
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    };

    // Clear all filters
    viewModel.SearchFilters.ClearAllSearchFilters = function (allFilters) {
        viewModel.SearchFilters.KeywordFilter('');
        viewModel.ResetDropDowns("All");
        viewModel.SearchFilters.ClearAdvancedSearchFilters(allFilters);
    };

    viewModel.SearchFilters.ClearAdvancedSearchFilters = function (allFilters) {
        ko.utils.arrayForEach(viewModel.SearchFilters.PracticeFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.TypeFilters(), function (item) {
            item.IsSelected(false);
        });

        if(allFilters === true)
        {
            ko.utils.arrayForEach(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
                item.IsSelected(false);
            });
        }

        ko.utils.arrayForEach(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.EventTypeFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.PastDateFilters(), function (item) {
            item.IsSelected(false);
        });

        ko.utils.arrayForEach(viewModel.SearchFilters.FutureDateFilters(), function (item) {
            item.IsSelected(false);
        });

        viewModel.SearchFilters.DateFrom('');
        viewModel.SearchFilters.DateTo('');
    };

    viewModel.ResetPracticeFilter = function (itemType) {
        viewModel.ResetDropDowns(itemType);
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    };

    viewModel.ResetDropDowns = function (itemType) {
        switch (itemType) {
            case "practice":
                ko.utils.arrayForEach(viewModel.SearchFilters.PracticeFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "industry":
                ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "publication":
                ko.utils.arrayForEach(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "event":
                ko.utils.arrayForEach(viewModel.SearchFilters.EventTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "date":
                ko.utils.arrayForEach(viewModel.SearchFilters.PastDateFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.FutureDateFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "news":
                ko.utils.arrayForEach(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "blog":
                ko.utils.arrayForEach(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                break;
            case "All":
                ko.utils.arrayForEach(viewModel.SearchFilters.PracticeFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.EventTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.PastDateFilters(), function (item) {
                    item.IsSelected(false);
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.FutureDateFilters(), function (item) {
                    item.IsSelected(false);
                });
                viewModel.ActiveArticleTypeFilter("All");
                viewModel.ResetAllDropdowns();
                break;
        }
    };

    // Clear Keyword Filter
    viewModel.SearchFilters.KeywordFilter.ClearFilter = function () {
        viewModel.SearchFilters.KeywordFilter('');
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    };

    // Set selected filters
    viewModel.SetSelectedFilters = function () {
        viewModel.SelectedFilters.removeAll();
        if (viewModel.SearchFilters.KeywordFilter() != null && viewModel.SearchFilters.KeywordFilter().length > 0) {
            var newItem = {
                ID: ko.observable(keyWordIDKey),
                IsEnabled: ko.observable(true),
                IsSelected: ko.observable(false),
                Name: ko.observable(viewModel.SearchFilters.KeywordFilter()),
                Label: ko.observable(option.keyWordLabel),
                Url: ko.observable('#0')
            };
            newItem.ClearFilter = function () {
                viewModel.SearchFilters.KeywordFilter('');
                viewModel.HasPendingUpdates(true);
                viewModel.Search();
            };
            viewModel.SelectedFilters.push(newItem);
        }
        ko.utils.arrayForEach(viewModel.SearchFilters.PracticeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
		});
		ko.utils.arrayForEach(viewModel.SearchFilters.OfficeFilters(), function (item) {
			if (item.IsSelected() == true) {
				viewModel.SelectedFilters.push(item);
			}
		});
        ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.TypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.ArticleTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
                viewModel.ActiveArticleTypeFilter(item.ParentName());
            }
            if (viewModel.EventTypeFilter() !== "" && item.ID() === "28d902b3-ee71-40e7-8283-d7317f82648a")
                viewModel.EventTypeFilter(item);
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.PublicationTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.EventTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.NewsTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.BlogTypeFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.PastDateFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.FutureDateFilters(), function (item) {
            if (item.IsSelected() == true) {
                viewModel.SelectedFilters.push(item);
            }
        });
    }

    // Set filters that might have been included from a back button
    viewModel.SetSelectedFilters();

    // Apply Bindings
    viewModel.Init(viewModel);
    ko.applyBindings(viewModel, pageContent.get(0));

    // Check for scroll in query string
    var qsParms = parseQueryString(window.location.href);
    var scrollPosition = 0;
    if (!!qsParms.scroll && qsParms.scroll.length > 0) {
        scrollPosition = parseInt(qsParms.scroll);
    }
    if (viewModel.SelectedFilters().length > 0) {
        viewModel.HasSearchRun(true);
        viewModel.IsSelectAll(false);
        viewModel.IsClearAll(false);
        viewModel.DisplaySetFilters(true);
    } else {
        viewModel.IsSelectAll(true);
        viewModel.IsClearAll(false);
        var searchCriteriaCookie = $.cookie('_home_page_search_critera');
        if (!!searchCriteriaCookie) {
            viewModel.ScrollPositionUpdate(false);
            History.pushState({ qs: searchCriteriaCookie }, History.options.initialTitle, searchCriteriaCookie);
        }
    }
    $("html, body").animate({ scrollTop: scrollPosition }, "slow");
};
